<template>
	<div class="chinaEuropeTrain">

		<Header :typeHeader="'defaultHeader'">
			<!-- banner -->
			<img slot="headerImage" :src="imgList.bannerImg" alt="">
			<!-- 标题 -->
			<div slot="headerTitle">{{$store.state.navShow == true ?'海外仓＋境外产品展销中心':'Overseas warehouse'}}</div>
			<div style="font-size: 1.125rem; color: #FFFFFF; font-weight: 100; margin-top: 0.6rem;" slot="headerTitle">
				<countTo v-if="$store.state.navShow == true" :startVal='0' :endVal='100000' :separator='null' :duration='3000'></countTo>
				<span v-if="$store.state.navShow == true">㎡欧洲甲级仓库资质标准</span>
				{{$store.state.navShow == true ?'':'10000㎡ European Class A warehouse qualification standard'}}
			</div>
		</Header>

		<div class="TopTitle" data-aos="fade-right">
			<!-- data-aos="fade-up-left" -->
			<div class="">
				<!-- {{this.$route.name}} -->
				{{$store.state.navShow == true ? $route.name : $route.meta.EnName}}
			</div>
		</div>
		<!-- fade-down -->
		<div class="ContentText" v-if="$store.state.navShow == true" data-aos="slide-right">
			<p style="margin-bottom:0;">MG集团在俄罗斯莫斯科建有<countTo :startVal='0' :endVal='100000' :separator='null' :duration='3000'></countTo>㎡的海外仓，具有欧洲甲级仓库资质标准，拥有先进的仓储分拨信息管理系统、现代化的仓储设备和专业高效的本土化运营团队，俄方员工超过95%，可为外贸企业提供专业的跨境贸易服务。2019年，被河北省商务厅认定为“河北公共海外仓”，成为俄罗斯首家河北海外仓，并在海外仓内建设境外河北产品展示中心。</p>
			<p>海外仓及其配套的海外展示中心可实现直接与厂商代表面对面交流的购物体验，优化购物体验的同时为中国中小企业产品进入当地市场提供报关清关、仓储物流、市场推广、渠道拓展等综合服务，未来将以电商平台海外仓为发展方向，提升中国产品在当地的占有率和知名度。</p>
		</div>
			<div class="ContentText" v-else data-aos="slide-right">
			<p>MG Group has an overseas warehouse of 100,000 square meters in Moscow, Russia, with European Grade A warehouse qualification standard, advanced storage allocation information management system, modern storage equipment and professional and efficient localization operation team, and more than 95% of Russian employees, which can provide professional cross-border trade services for foreign trade enterprises. In 2019, it was identified as "Hebei Public overseas warehouse" by Hebei Department of Commerce, becoming the first Hebei overseas warehouse in Russia, and has built overseas Hebei products exhibition center in the overseas warehouse.</p>
			<p>Overseas warehouse and its supporting overseas exhibition center can realize direct face-to-face communication with manufacturer representative, optimize the shopping experience, provide comprehensive services such as customs declaration and clearance, warehousing and logistics, market promotion, channel expansion for the products of Chinese small and medium-sized enterprises to enter the local market. In the future, it will take the overseas warehouse of e-commerce platform as the development direction to improve the local share and popularity of Chinese products.</p>
		</div>

		<!-- 优势 -->
		<div class="ContentAdvantage">
			<div class="advantageNumber" :style="$store.state.navShow == true? 'height: 9.84375rem':'height: 11rem' ">
				<div class="advantageNumberImg">
					<img src="../../assets/OverseasWarehouse/advantage.png">
				</div>
				<div class="advantageNumberTitle">
					<p class="tableTitleTitle">{{$store.state.navShow == true?'海外仓优势' : 'Overseas warehouse advantage'}}</p>
				</div>
				<div class="advantageNumberText">
					<div class="advantageNumberTextList">
						<div class="advantageNumberTextList_1" >

							<countTo :startVal='0' :endVal='100000' :separator='null' :duration='3000'></countTo>
						</div>
						<div class="advantageNumberTextList_2" >
							{{$store.state.navShow == true?'占地面积平方米':'Covers an area of square meters'}}
						</div>
					</div>
					<div class="advantageNumberTextList">
						<div class="advantageNumberTextList_1" >

							<countTo :startVal='0' :endVal='95' :separator='null' :duration='3000'></countTo>
							<span>%</span>
						</div>
						<div class="advantageNumberTextList_2" >
							{{$store.state.navShow == true?'俄方员工占比': 'Russian employees account for '}}
						</div>
					</div>
					<div class="advantageNumberTextList">
						<div class="advantageNumberTextList_1" >

							<countTo :startVal='0' :endVal='15' :duration='3000'></countTo>
							<span>km</span>
						</div>
						<div class="advantageNumberTextList_2" >
							{{$store.state.navShow == true?'距离市区': 'from the urban area'}}
						</div>
					</div>
					<div class="advantageNumberTextList">
						<div class="advantageNumberTextList_1" >

							<countTo :startVal='0' :endVal='30' :duration='3000'></countTo>
							<span>km</span>
						</div>
						<div class="advantageNumberTextList_2" >
							{{$store.state.navShow == true?'距离两个机场' : 'from the two airports'}}
						</div>
					</div>
				</div>
			</div>
			<div class="advantageOne">
				<div class="advantageOne_1" >
					<img src="../../assets/OverseasWarehouse/individualization.png">
					<div class="advantageOne_1_Text">
						{{$store.state.navShow == true? '大客户个性化定制服务':'For major customers Customized service'}}
					</div>
				</div>
				<div class="advantageOne_2" >
					<img src="../../assets/OverseasWarehouse/customerservice.png">
					<div class="advantageOne_2_Text">
						{{$store.state.navShow == true?'优秀的客服管理团队':'Excellent customer service Management team'}}
					</div>
				</div>
			</div>
			<div class="advantageTwo">
				<div class="advantageTwo_1" data-aos="fade-up" :style="$store.state.navShow == true?'' :'height: 13rem;' ">
					<img src="../../assets/OverseasWarehouse/storage.png">
					<div class="advantageTwo_1_Text">
						{{$store.state.navShow == true?'专业的仓储信息化系统':'Professional warehousing Information system'}}
					</div>
				</div>
				<div class="advantageTwo_1" data-aos="fade-up" :style="$store.state.navShow == true?'' :'height: 13rem;' ">
					<img src="../../assets/OverseasWarehouse/RMap.png">
					<div class="advantageTwo_1_Text">
						{{$store.state.navShow == true?'俄罗斯全境派送不分区':'The whole territory of Russia is delivered Without division'}}
					</div>
				</div>
				<div class="advantageTwo_1" data-aos="fade-up" :style="$store.state.navShow == true?'' :'height: 13rem;' ">
					<img src="../../assets/OverseasWarehouse/fleet.png">
					<div class="advantageTwo_1_Text">
						{{$store.state.navShow == true?'专属的车队派送':'Exclusive Fleet delivery'}}
					</div>
				</div>
			</div>

			<div class="Warehouse">
				<img v-if="$store.state.navShow == true" src="../../assets/OverseasWarehouse/Warehouse01.jpg" data-aos="fade-up">
				<img v-else src="../../assets/OverseasWarehouse/Warehouse01E.jpg" data-aos="fade-up">
			</div>

			<div class="WarehouseBottom">
				<img class="WarehouseBottom02" src="../../assets/OverseasWarehouse/Warehouse03.jpg">
				<img v-if="$store.state.navShow == true" class="WarehouseBottom03" src="../../assets/OverseasWarehouse/Warehouse02.jpg">
				<img v-else class="WarehouseBottom03" src="../../assets/OverseasWarehouse/Warehouse02E.jpg">
				<img class="WarehouseBottom03" src="../../assets/OverseasWarehouse/Warehouse04.jpg">
			</div>

 

		</div>













		<div class="buttonImgOW">
<!-- 			<img :src="imgList.bottonImg">
			<img :src="imgList.currency"> -->
			<img src="../../assets/OverseasWarehouse/botton.png">
			<img src="../../assets/OverseasWarehouse/currency.png">
		</div>
	</div>
</template>

<script>
	import Header from "@/components/header.vue";
	// 引入数字滚动的依赖(插件)
	import countTo from 'vue-count-to'
	export default {
		components: {
			Header,
			countTo
		},
		data() {
			return {
				imgList: {
					bannerImg: require('@/assets/OverseasWarehouse/banner.jpg'),
					// backgroundImg: require('@/assets/chinaAndRussia/backgroundImg.png'),
					currency: require('@/assets/OverseasWarehouse/currency.png'),
					bottonImg: require('@/assets/OverseasWarehouse/botton.png'),
				},
			}
		},
		methods: {


		}
	}
</script>
<!-- 头部 -->
<style lang="less">
	.TopTitle {

		width: 92%;
		height: 4.95rem;
		position: relative;
		margin: 0 4%;
		top: -3.2rem;
		border-bottom: 1px solid rgba(204, 204, 204, .5);

		&>div {
			position: absolute;
			top: 1.25rem;
			font-size: 1rem;
			font-family: Microsoft YaHei;
			font-weight: bold;
			color: #FFFFFF;
			padding: 1.2rem 3.375rem 1.2rem 0.75rem;
			background: #2e67b1 linear-gradient(270deg, rgba(3, 0, 0, .15), hsla(0, 0%, 100%, .15));
		}
	}

	.ContentText {
		width: 92%;
		margin: 0 4%;
		// background-color: #000066;
		margin-top: -1.575rem;
		text-align: left;

		&>p {
			font-size: 0.875rem;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #666666;
			text-indent: 2em;
			margin-bottom: 1.25rem;
			text-align: justify;
		}
	}
</style>

<style lang="less">
	.ContentAdvantage {
		width: 92%;
		margin: 0 4%;
		z-index: 2;


		.advantageNumber {
			position: relative;
			height: 9.84375rem;

			&>div {
				position: absolute;
			}

			.advantageNumberImg {
				width: 50%;
				height: 6.5rem;
				top: 0;
				right: 0;

				&>img {
					width: 100%;
					height: 100%;
				}
			}

			.advantageNumberTitle {
				top: 1.425rem;
				left: 0rem;
			}

			.advantageNumberText {
				width: 100%;
				bottom: 0.47625rem;
				background-color: rgba(46, 103, 177, 1);
				display: flex;
				justify-content: space-evenly;
				align-items: center;

				.advantageNumberTextList {
					padding-top: 1.40625rem;
					padding-bottom: 1.3125rem;

					.advantageNumberTextList_1 {
						span {
							font-size: 1.475rem;
							font-family: AkzidenzGroteskBQ;
							font-weight: normal;
							color: #FFFFFF;
						}

						margin-bottom: 0.45rem;

						&>span:nth-child(2) {
							font-size: 0.7375rem;
						}
					}

					.advantageNumberTextList_2 {
						font-size: 0.725rem;
						font-family: Microsoft YaHei;
						font-weight: 400;
						color: #FFFFFF;
					}
				}
			}

		}

		.advantageOne {
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-top: 0.9375rem;
			margin-bottom: 0.625rem;

			.advantageOne_1 {
				width: 48.5%;
				box-shadow: 0px 0px 20px 0px rgba(41, 92, 169, 0.1);
				display: flex;
				align-items: center;
				justify-content: space-around;

				&>img {
					width: 1.53125rem;
					height: 2.836875rem;
					margin-top: 2.15625rem;
					margin-left: 1.9375rem;
					margin-bottom: 0.8125rem;
				}

				.advantageOne_1_Text {
					font-size: 0.6875rem;
					font-family: Microsoft YaHei;
					font-weight: 400;
					color: #666666;
					width: 53%;
					text-align: left;
					margin-left: 1.625rem;
					margin-right: 1.21875rem;
				}
			}

			.advantageOne_2 {
				width: 48.5%;
				box-shadow: 0px 0px 20px 0px rgba(41, 92, 169, 0.1);
				display: flex;
				align-items: center;
				justify-content: space-around;

				&>img {
					width: 2.09375rem;
					height: 2.8375rem;
					margin-top: 2.15625rem;
					margin-left: 1.9375rem;
					margin-bottom: 0.8125rem;
				}

				.advantageOne_2_Text {
					font-size: 0.6875rem;
					font-family: Microsoft YaHei;
					font-weight: 400;
					color: #666666;
					width: 53%;
					text-align: left;
					margin-left: 1.625rem;
					margin-right: 1.21875rem;
				}
			}
		}

		.advantageTwo {
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.advantageTwo_1 {
				box-shadow: 0px 0px 20px 0px rgba(41, 92, 169, 0.1);
				width: 31%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;

				&>img {
					width: 1.75rem;
					height: 2.525rem;
					margin-bottom: 1.21875rem;
					margin-top: 1.875rem;
				}

				.advantageTwo_1_Text {
					width: 60%;
					font-size: 0.6875rem;
					font-family: Microsoft YaHei;
					font-weight: 400;
					color: #666666;
					margin-bottom: 0.8125rem;
				}
			}
		}

		.advantageTwo_1:nth-child(2) {
			&>img {
				width: 4.65625rem;
				height: 2.524375rem;
			}
		}

		.Warehouse {
			margin-top: 1.90625rem;
			width: 100%;
			height: 13.5rem;

			&>img {
				width: 100%;
				height: 100%;
			}
		}

		.WarehouseBottom {
			width: 100%;
			height: 9.21875rem;
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-top: 0.7rem;
			position: relative;

			&>img {
				position: absolute;
				height: 100%;
			}

			&>img:nth-child(1) {
				// width: 8.4375rem;
				width: 40%;
				left: 0;
			}

			&>img:nth-child(2) {
				// width: 12.375rem;
				width: 57%;
				right: 0;
			}

			&>img:nth-child(3) {
				// width: 12.375rem;
				width: 28%;
				height: 70%;
				left: 0;
				bottom: -34%;
			}
		}
	}

	// 小标题
	.tableTitleTitle {
		// margin: 1.875rem 0 0.625rem 0;
		font-size: 0.95rem;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #2E67B1;
		text-align: left;
		margin-bottom: 1.0375rem;
	}

	.buttonImgOW {

		width: 100%;
		height: 8rem;
		z-index: 1;
		position: relative;

		&>img:nth-child(1) {
			width: 70%;
			height: 9rem;
			position: absolute;
			right: 0;
			bottom: 2rem;
			z-index: 1;
		}

		&>img:nth-child(2) {
			position: absolute;
			width: 100%;
			height: 4rem;
			left: 0;
			bottom: 0;
		}
	}
</style>
